import ApplicationAdapter, { projectChildMixin } from "./application";

export default class ReservedIpAdapter extends ApplicationAdapter.extend(projectChildMixin) {
  uriSuffix = "ips";
}
